
    import Vue from "vue";

    const END_POINT = "/center";

    const getLocation = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllLocations = data => Vue.axios.get(END_POINT, {params: data});

    const createLocation = location => Vue.axios.post(END_POINT,  location );

    const createAllLocations = Locations => Vue.axios.post(END_POINT + "/all",  Locations );

    const updateLocation = location => Vue.axios.put(END_POINT  + "/" + location.id,  location );

    const deleteLocation = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getLocation,
      getAllLocations,
      createLocation,
      createAllLocations,
      updateLocation,
      deleteLocation
    };
    